var $ = jQuery;

import Swiper from 'swiper';

$(document).on('ready', function(){
    if($('.platforms-swiper').length){
      $('.platforms-swiper').each(function(index){
          new Swiper($(this)[0], {
          slidesPerView: 2.3,
          mousewheelControl: true,
          loop: false,
          spaceBetween: 0,
          breakpoints: {
            300: {
              slidesPerView: 1,
              speed:800,
            },
            500: {
              slidesPerView: 2,
              speed:800,
           },
            1400: {
              slidesPerView: 2.3,
              autoHeight: true,
            },
          },
        });
      });
    }
  });
